import {
  Offers
} from "@/services/offers.service"; //TODO: porządek z api

const state = {
  offers: [],
  products: []
};

const getters = {
  offers(state) {
    return state.offers;
  },
};

const actions = {
  async getOffers({
    commit
  }, constructionId) {
    let data = await Offers.getOffers(constructionId);
    commit('setOffers', data.offers);
    return data.offers;
  },
  async addOffer({
    commit,
  }, body) {
    let offer = await Offers.addOffer(body);
    commit('offerPush', offer);
    return offer;
  },
  async editOffer({ commit }, body) {
    let offer = await Offers.editOffer(body);

    commit('offerUpdate', { offer });
  },
  offerRemove({
    state,
    commit
  }, query) {
    if (!query) return;
    return Offers.offerRemove(query)
      .then(() => {
        let removed = state.offers.filter((offer) => {
          return offer.id !== query.offerId
        })
        commit('setOffers', [...removed]);
      });
  },
};


const mutations = {
  setOffers(state, offers) {
    state.offers = offers;
  },
  offerPush(state, payload) {
    state.offers.unshift(payload);
  },
  offerUpdate(state, {
    offer
  }) {
    let offerIndex = state.offers.findIndex((item) => (item.id === offer.id));
    if (offerIndex >= 0){
      let stateOffert = state.offers[offerIndex];
      stateOffert.name = offer.name;
      stateOffert.description= offer.description;
      stateOffert.end_date= offer.end_date;
      stateOffert.netto_amount= offer.netto_amount;
      stateOffert.start_date= offer.start_date;
      stateOffert.vat_amount= offer.vat_amount;
    }
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};